import { render, staticRenderFns } from "./ClassManagement.vue?vue&type=template&id=06f0c6cc&scoped=true"
import script from "./ClassManagement.vue?vue&type=script&lang=js"
export * from "./ClassManagement.vue?vue&type=script&lang=js"
import style0 from "./ClassManagement.vue?vue&type=style&index=0&id=06f0c6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0c6cc",
  null
  
)

export default component.exports